import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  function Label({ className, ...rest }, ref) {
    return (
      <label
        ref={ref}
        className={cn(
          // Tipografia herda do .field (container pai: label+input) — fs-base/
          // fw-bold do handoff. O Label em si so precisa do estado disabled.
          "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
          className,
        )}
        {...rest}
      />
    );
  },
);
